import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app/store";
import { loadUserSession } from "./features/user/userSlice";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { setDefaultOptions } from "date-fns";

const container = document.getElementById("root")!;
const root = createRoot(container);

// Set Monday as the first day of the week
setDefaultOptions({ weekStartsOn: 1 });

// load user session from local storage
store.dispatch(loadUserSession());

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
